(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scrunchy-before-after"] && !Shopify.designMode) return;
  try {
    
(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function initCarousel(root) {
    if (root.dataset.sbaReady === 'true') return;
    root.dataset.sbaReady = 'true';

    var track = root.querySelector('[data-sba-track]');
    if (!track) return;

    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-sba-slide]'));
    if (slides.length < 2) return;

    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-sba-dot]'));
    var prev = root.querySelector('[data-sba-prev]');
    var next = root.querySelector('[data-sba-next]');
    var playPause = root.querySelector('[data-sba-playpause]');
    var live = root.querySelector('[data-sba-live]');

    var wantsAutoplay = root.dataset.autoplay === 'true';
    var interval = parseInt(root.dataset.interval, 10) || 5000;
    var index = 0;
    var timer = null;
    var userPaused = false;

    function goTo(i, smooth) {
      index = (i + slides.length) % slides.length;
      var target = slides[index];
      // Centre the slide rather than aligning it left — with the peek padding
      // the two are no longer the same, and aligning left pushes the active
      // slide off-centre by exactly the peek width.
      var offsetInTrack = target.offsetLeft - track.offsetLeft;
      var centred = offsetInTrack - (track.clientWidth - target.clientWidth) / 2;
      track.scrollTo({
        left: centred,
        behavior: smooth === false || reduceMotion.matches ? 'auto' : 'smooth'
      });
      sync();
    }

    function sync() {
      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === index);
      });
      dots.forEach(function (dot, i) {
        dot.setAttribute('aria-selected', i === index ? 'true' : 'false');
      });
      if (live) live.textContent = 'Result ' + (index + 1) + ' of ' + slides.length;
    }

    function canRun() {
      return wantsAutoplay && !userPaused && !reduceMotion.matches && !document.hidden;
    }

    function start() {
      stop();
      if (!canRun()) return;
      timer = window.setInterval(function () { goTo(index + 1); }, interval);
    }

    function stop() {
      if (timer) { window.clearInterval(timer); timer = null; }
    }

    // Keep the active slide honest when the visitor swipes.
    // Test intersectionRatio, not isIntersecting: with the peek, the two
    // neighbours are always technically intersecting, so isIntersecting alone
    // would hand "active" to whichever slide reported last and make the
    // highlight flicker between them.
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.intersectionRatio >= 0.6) {
            var i = slides.indexOf(entry.target);
            if (i > -1 && i !== index) { index = i; sync(); }
          }
        });
      }, { root: track, threshold: [0.6] });
      slides.forEach(function (slide) { io.observe(slide); });
    }

    // Dimming only applies once JS is driving, so a broken script leaves every
    // slide readable instead of permanently faded.
    root.classList.add('sba--enhanced');

    // Tapping a peeking neighbour pulls it to the centre — the obvious thing to
    // try once you can see part of it.
    slides.forEach(function (slide, i) {
      slide.addEventListener('click', function () {
        if (i === index) return;
        goTo(i);
        start();
      });
    });

    if (prev) prev.addEventListener('click', function () { goTo(index - 1); start(); });
    if (next) next.addEventListener('click', function () { goTo(index + 1); start(); });

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(parseInt(dot.dataset.sbaDot, 10));
        start();
      });
    });

    if (playPause) {
      playPause.addEventListener('click', function () {
        userPaused = !userPaused;
        playPause.setAttribute('aria-pressed', userPaused ? 'true' : 'false');
        playPause.setAttribute('aria-label', userPaused ? 'Play the slideshow' : 'Pause the slideshow');
        var label = playPause.querySelector('.sba__pp-text');
        if (label) label.textContent = userPaused ? 'Play' : 'Pause';
        if (userPaused) { stop(); } else { start(); }
      });
    }

    // Pause while the visitor is actually looking at or touching a slide.
    root.addEventListener('pointerenter', stop);
    root.addEventListener('pointerleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', function (e) {
      if (!root.contains(e.relatedTarget)) start();
    });
    track.addEventListener('touchstart', stop, { passive: true });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { stop(); } else { start(); }
    });

    if (reduceMotion.addEventListener) {
      reduceMotion.addEventListener('change', function () {
        if (reduceMotion.matches) { stop(); } else { start(); }
      });
    }

    // Only autoplay once it is actually on screen.
    if ('IntersectionObserver' in window) {
      var vis = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) { start(); } else { stop(); }
        });
      }, { threshold: 0.25 });
      vis.observe(root);
    } else {
      start();
    }

    sync();
  }

  // Lightbox is initialised separately from the carousel so tap-to-enlarge
  // still works on a section with a single slide (initCarousel bails early
  // when there is nothing to rotate).
  function initLightbox(root) {
    if (root.dataset.sbaZoomReady === 'true') return;

    var box = root.querySelector('[data-sba-lightbox]');
    if (!box) return;
    root.dataset.sbaZoomReady = 'true';

    var img = box.querySelector('[data-sba-lightbox-img]');
    var scroller = box.querySelector('[data-sba-lightbox-scroll]');
    var caption = box.querySelector('[data-sba-lightbox-caption]');
    var closers = box.querySelectorAll('[data-sba-lightbox-close]');
    var closeBtn = box.querySelector('.sba__lightbox-closebtn');
    var lastTrigger = null;

    function open(btn) {
      lastTrigger = btn;
      img.src = btn.dataset.full;
      img.alt = btn.dataset.alt || '';
      var text = btn.dataset.caption || '';
      caption.textContent = text;
      caption.hidden = !text;
      box.classList.remove('is-zoomed');
      box.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      if (closeBtn) closeBtn.focus();
    }

    function close() {
      box.hidden = true;
      document.documentElement.style.overflow = '';
      if (lastTrigger) lastTrigger.focus();
    }

    root.querySelectorAll('[data-sba-zoom]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        var slide = btn.closest('[data-sba-slide]');
        // A peeking neighbour navigates (the carousel's own slide handler);
        // only the centred slide opens the lightbox.
        if (slide && !slide.classList.contains('is-active')) return;
        e.stopPropagation();
        open(btn);
      });
    });

    closers.forEach(function (el) {
      el.addEventListener('click', close);
    });

    // Tap the photo to toggle a 2.2x zoom; the wrapper scrolls for panning.
    img.addEventListener('click', function () {
      var zoomingIn = !box.classList.contains('is-zoomed');
      box.classList.toggle('is-zoomed');
      if (zoomingIn) {
        scroller.scrollLeft = (scroller.scrollWidth - scroller.clientWidth) / 2;
        scroller.scrollTop = (scroller.scrollHeight - scroller.clientHeight) / 2;
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !box.hidden) close();
    });
  }

  function initAll() {
    document.querySelectorAll('[data-sba]').forEach(function (root) {
      initCarousel(root);
      initLightbox(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-sba]').forEach(function (root) {
      initCarousel(root);
      initLightbox(root);
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scrunchy-testimonials"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (root.dataset.stestReady === 'true') return;
    root.dataset.stestReady = 'true';
    root.classList.add('stest--enhanced');

    var track = root.querySelector('[data-stest-track]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-stest-card]'));
    var dotsWrap = root.querySelector('[data-stest-dots]');

    // Clamp long quotes; reveal the toggle only when clamping actually hides text.
    cards.forEach(function (card) {
      var quote = card.querySelector('[data-stest-quote]');
      var btn = card.querySelector('[data-stest-more]');
      if (!quote || !btn) return;
      quote.classList.add('is-clamped');
      // measure after clamp applies
      requestAnimationFrame(function () {
        if (quote.scrollHeight > quote.clientHeight + 2) {
          btn.hidden = false;
          btn.addEventListener('click', function () {
            var expanded = quote.classList.toggle('is-clamped') === false;
            btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
            btn.textContent = expanded ? 'Show less' : 'Read the full note';
          });
        }
      });
    });

    // Video tiles: overlay play button (revealed only here, so no-JS keeps
    // bare native controls), and starting one video pauses the others.
    root.querySelectorAll('[data-stestv]').forEach(function (tile) {
      var video = tile.querySelector('video');
      var btn = tile.querySelector('[data-stestv-play]');
      if (!video || !btn) return;
      btn.hidden = false;
      btn.addEventListener('click', function () {
        btn.hidden = true;
        video.play();
      });
      video.addEventListener('play', function () {
        root.querySelectorAll('video').forEach(function (other) {
          if (other !== video) other.pause();
        });
      });
    });

    // Dots only matter while the track scrolls (mobile). Rebuilt on resize
    // crossings is not worth the weight — they are simply hidden by CSS on desktop.
    if (!track || !dotsWrap || cards.length < 2) return;
    cards.forEach(function (card, i) {
      var dot = document.createElement('button');
      dot.className = 'stest__dot';
      dot.type = 'button';
      dot.setAttribute('role', 'tab');
      dot.setAttribute('aria-label', 'Testimonial ' + (i + 1));
      dot.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
      dot.addEventListener('click', function () {
        var left = card.offsetLeft - track.offsetLeft - (track.clientWidth - card.clientWidth) / 2;
        track.scrollTo({ left: left, behavior: 'smooth' });
      });
      dotsWrap.appendChild(dot);
    });
    var dots = Array.prototype.slice.call(dotsWrap.children);

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.intersectionRatio >= 0.6) {
            var i = cards.indexOf(entry.target);
            dots.forEach(function (d, j) { d.setAttribute('aria-selected', j === i ? 'true' : 'false'); });
          }
        });
      }, { root: track, threshold: [0.6] });
      cards.forEach(function (card) { io.observe(card); });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-stest]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-stest]').forEach(init);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
